// privatokonomi-messages-part2 translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'pkn.gj.journey.debtFree': 'Libre de deudas',
  'pkn.gj.now': 'Ahora',
  'pkn.gj.fillRequired': 'Introduce el nombre, la deuda pendiente y el interés',
  'pkn.gj.editLoan': 'Editar préstamo',
  'pkn.gj.addLoan': 'Añadir préstamo',
  'pkn.gj.fieldName': 'Nombre del préstamo',
  'pkn.gj.phName': 'P. ej. Préstamo hipotecario',
  'pkn.gj.fieldLender': 'Prestamista / tipo',
  'pkn.gj.phLender': 'P. ej. Préstamo de cuota fija · DNB',
  'pkn.gj.fieldBalance': 'Deuda pendiente (kr)',
  'pkn.gj.fieldOriginal': 'Préstamo original (kr)',
  'pkn.gj.optionalLower': 'opcional',
  'pkn.gj.fieldNominal': 'Interés nominal (%)',
  'pkn.gj.fieldEffective': 'Interés efectivo (%)',
  'pkn.gj.optionalUpper': 'Opcional',
  'pkn.gj.fieldTerm': 'Meses restantes',
  'pkn.gj.annuityLoan': 'Préstamo de cuota fija',
  'pkn.gj.serialLoan': 'Préstamo de amortización constante',
  'pkn.gj.serialHint': 'Préstamo de amortización constante: amortización fija cada mes; la cuota es más alta al principio y baja a medida que disminuye la deuda.',
  'pkn.gj.annuityHint': 'Préstamo de cuota fija: la misma cuota durante todo el plazo; la parte de capital aumenta mientras la de intereses disminuye.',
  'pkn.gj.postedAs': 'Los intereses y las amortizaciones de este préstamo se muestran como «{category}» en Gastos.',
  'pkn.gj.categoryFallback': 'categoría',
  'pkn.gj.loanFallback': 'Préstamo',
  'pkn.gj.editNamed': 'Editar {name}',
  'pkn.gj.observedIn': 'Observado en {count} transacciones',
  'pkn.gj.calculatedFrom': 'Calculado a partir de los datos del préstamo',
  'pkn.gj.observed': 'observado',
  'pkn.gj.highestEffective': 'Interés efectivo más alto ({rate}): cuesta unos {interest} de intereses al año.',
  'pkn.gj.highest': 'Interés más alto ({rate}): cuesta unos {interest} de intereses al año.',
  'pkn.gj.laterLoan': 'Interés {rate} · unos {interest} de intereses al año. Ocúpate de este cuando los préstamos más caros estén liquidados.',
  'pkn.gj.bufferFirst': 'Primero termina de construir el colchón de efectivo. Faltan',
  'pkn.gj.bufferFirstSuffix': 'para alcanzar el objetivo del colchón antes de priorizar amortizaciones extra.',
  'pkn.gj.snowA': 'paga el mínimo en todo, pero destina el dinero extra a',
  'pkn.gj.snowB': 'con un interés del {rate}. Cuando esté liquidado, pasa esa cantidad al siguiente más caro.',
  'pkn.gj.planTitle': 'Plan de amortización · {name}',
  'pkn.gj.extraPerMonth': '{amount} extra al mes',
  'pkn.gj.makesDebtFree': 'te libera de la deuda de {name}',
  'pkn.gj.earlier': '{time} antes',
  'pkn.gj.andKeep': 'y te permite conservar',
  'pkn.gj.toBank': 'que de otro modo habrían ido al banco en intereses.',
  'pkn.gj.activated': 'Activado',
  'pkn.gj.tryRecommendation': 'Probar la recomendación',
  'pkn.gj.standard': 'Estándar',
  'pkn.gj.heroEarlier': 'Te liberas de la deuda antes',
  'pkn.gj.heroLonger': 'Esto alarga el plazo',
  'pkn.gj.heroDrag': 'Mueve el control deslizante y mira qué ocurre',
  'pkn.gj.earlierWord': 'antes',
  'pkn.gj.laterWord': 'después',
  'pkn.gj.interestSaved': 'Ahorrado en intereses',
  'pkn.gj.interestMore': 'Más en intereses',
  'pkn.gj.paymentNow': 'Cuota actual',
  'pkn.gj.newMonthlyPayment': 'Nuevo pago mensual',
  'pkn.gj.declines': 'Baja a medida que disminuye la deuda',
  'pkn.gj.standardAmount': 'Estándar {amount}',
  'pkn.gj.timeLeft': 'Quedan {time}',
  'pkn.gj.inSpendingSuffix': 'en Gastos, para que puedas distinguir fácilmente el préstamo del resto de tus gastos.',
  'pkn.ov.tone.insight': 'Información',
  'pkn.ov.tone.milestone': 'Hito',
  'pkn.ov.tone.opportunity': 'Oportunidad',
  'pkn.ov.tone.tax': 'Impuestos',
  'pkn.ov.tone.save': 'Ahorra dinero',
  'pkn.ov.tone.alert': 'Aviso',
  'pkn.ov.verdict.healthy': 'Finanzas saludables',
  'pkn.ov.verdict.stable': 'Finanzas estables',
  'pkn.ov.verdict.needsFollowUp': 'Requiere seguimiento',
  'pkn.ov.stat.finances': 'Finanzas',
  'pkn.ov.stat.potentialSaving': 'Ahorro potencial',
  'pkn.ov.stat.needsFollowUp': 'Requiere seguimiento',
  'pkn.ov.things': '{count} elementos',
  'pkn.ov.stat.healthScore': 'Puntuación de salud financiera',
  'pkn.ov.goToTopTask': 'Ir a la tarea más importante',
  'pkn.ov.allDone': 'Todo completado',
  'pkn.ov.noneYet': 'Ninguna todavía',
  'pkn.ov.remainingCount': 'Quedan {count}',
  'pkn.ov.howAdviceCalculated': 'Cómo se ha calculado el consejo',
  'pkn.ov.showFewer': 'Mostrar menos tareas',
  'pkn.ov.seeAll': 'Ver todas las tareas ({count})',
  'pkn.ov.noNewTasks': 'No hay tareas nuevas por ahora. Sube más extractos bancarios para obtener una imagen más fiable y actualizada.',
  'pkn.ov.allTicked': 'Todo está marcado por hoy. Seguiré atento y te avisaré cuando ocurra algo.',
  'pkn.ov.doneToday': 'Completado hoy · {count}',
  'pkn.ov.completed': 'completado',
  'pkn.ov.hidden': 'oculto',
  'pkn.ov.group.wealth': 'Patrimonio y balance',
  'pkn.ov.group.cashflow': 'Flujo de caja mensual',
  'pkn.ov.preliminary': 'Provisional · los datos están incompletos',
  'pkn.ov.sinceLastMonth': 'desde el mes pasado',
  'pkn.ov.bestEver': 'Mejor marca: {score}',
  'pkn.ov.trendMonths': 'Evolución de los últimos {count} meses',
  'pkn.ov.mascotAlt': 'SuperPlumma con una planta que crece',
  'pkn.ov.howKpisCalculated': 'Cómo se calculan las cifras clave',
  'pkn.ov.kpiExplanation': 'Entradas son los ingresos registrados. Salidas son el gasto ordinario. El flujo de caja neto es el ingreso menos el gasto ordinario, los pagos de préstamos y el ahorro/inversión. Se excluyen tus propias transferencias y las liquidaciones de tarjeta de crédito. Los activos y las deudas se pueden conciliar con los registros de sus páginas correspondientes.',
  'pkn.ov.noScoreA': 'No puedo asignar una puntuación de salud financiera a tus finanzas hasta que tenga cifras con las que calcular',
  'pkn.ov.noScoreB': 'Sube un extracto bancario en Importar y analizaré tus ingresos, gastos, ahorro y deuda, y te diré cómo vas.',
  'pkn.ov.andChanged': 'y ha cambiado en',
  'pkn.ov.points': 'puntos',
  'pkn.ov.thinBasis': 'Ten en cuenta que la base sigue siendo escasa: más meses importados dan una imagen más fiable.',
  'pkn.ov.watchExtra': 'Lo único que sigo con especial atención es',
  'pkn.rpt.verdict.strong': 'Mes sólido',
  'pkn.rpt.verdict.solid': 'Buen mes',
  'pkn.rpt.verdict.fine': 'Mes aceptable',
  'pkn.rpt.verdict.mixed': 'Mes irregular',
  'pkn.rpt.verdict.demanding': 'Mes exigente',
  'pkn.rpt.wholeYear': 'Todo {year}',
  'pkn.rpt.ppVs': '{delta} pp frente a {year}',
  'pkn.rpt.pctVs': '{pct} frente a {year}',
  'pkn.rpt.empty.bad': 'Sin transacciones importadas no puedo señalar qué conviene mejorar.',
  'pkn.rpt.empty.focus': 'Sube un extracto bancario en Importar y escribiré un resumen completo del periodo para ti.',
  'pkn.rpt.empty.good': 'Todavía no hay nada que valorar.',
  'pkn.rpt.empty.lead': 'Todavía no tengo transacciones importadas de {period}, así que no puedo escribir un resumen del periodo. Sube un extracto bancario en Importar y leeré las cifras para contarte cómo fue el mes.',
  'pkn.rpt.moverUp': 'Lo que más se movió fue {name}, que aumentó {amount} frente a {period}.',
  'pkn.rpt.moverDown': 'Lo que más se movió fue {name}, que bajó {amount} frente a {period}.',
  'pkn.rpt.strengthYes': 'En comparación con {period}, has reforzado tus finanzas en este periodo.',
  'pkn.rpt.strengthNo': 'En comparación con {period}, has gastado algo más de tu excedente en este periodo.',
  'pkn.rpt.rhythm.healthy': 'Es un ritmo saludable que conviene mantener: vas construyendo seguridad mes a mes.',
  'pkn.rpt.rhythm.fine': 'Es un ritmo aceptable, pero hay margen para apartar algo más.',
  'pkn.rpt.rhythm.low': 'Aquí vale la pena ver si se puede liberar algo para ahorrar el próximo mes.',
  'pkn.rpt.leadNamed': '{name}, en {period} tuviste {income} de ingresos y {cost} en gasto ordinario. Después del gasto, los pagos de deuda y el ahorro registrado, el flujo de caja neto fue de {saved}. El ahorro registrado representó el {rate} % de los ingresos.',
  'pkn.rpt.lead': 'En {period} tuviste {income} de ingresos y {cost} en gasto ordinario. Después del gasto, los pagos de deuda y el ahorro registrado, el flujo de caja neto fue de {saved}. El ahorro registrado representó el {rate} % de los ingresos.',
  'pkn.rpt.good.incomeUp': 'Los ingresos aumentaron {pct} frente a {year}.',
  'pkn.rpt.good.rateUp': 'La tasa de ahorro subió del {from} % al {to} %.',
  'pkn.rpt.good.costDown': 'Los gastos bajaron {pct}, menos que en el mismo periodo del año pasado.',
  'pkn.rpt.good.lessOn': 'Gastaste {amount} menos en {name}.',
  'pkn.rpt.good.rateHealthy': 'Una tasa de ahorro del {rate} % es saludable: supera el umbral recomendado del 20 %.',
  'pkn.rpt.good.fixedStable': 'Los gastos fijos se mantienen estables durante el periodo.',
  'pkn.rpt.bad.costUp': 'Los gastos aumentaron {pct} frente a {year}.',
  'pkn.rpt.bad.rateDown': 'La tasa de ahorro bajó del {from} % al {to} %.',
  'pkn.rpt.bad.mostUp': '{name} fue lo que más aumentó: {pct} ({amount} más).',
  'pkn.rpt.bad.incomeLower': 'Los ingresos fueron {pct} menores que el año pasado.',
  'pkn.rpt.bad.rateLow': 'Una tasa de ahorro del {rate} % es algo baja; intenta apartar más el próximo mes.',
  'pkn.rpt.bad.nothing': 'Nada destaca de forma negativa en este periodo.',
  'pkn.rpt.focus.watch': 'Vigila {name} el próximo mes: es donde más aumentó el gasto y un pequeño ajuste tiene el efecto más rápido.',
  'pkn.rpt.focus.biggest': '{name} es tu mayor partida de gasto. Mira si se puede recortar algo ahí sin que lo note tu día a día.',
  'pkn.rpt.focus.continue': 'Sigue por el mismo camino el próximo mes y, si puedes, lleva algo más del excedente directamente a un objetivo de ahorro.',
  'pkn.rpt.obs.highestIncome': 'Los mayores ingresos del año hasta ahora: {amount}.',
  'pkn.rpt.obs.lowestCost': 'El gasto mensual más bajo en lo que va de año.',
  'pkn.rpt.obs.streak': '{count} meses seguidos con superávit: estás ahorrando de forma constante.',
  'pkn.rpt.obs.deviationOver': 'El gasto está un {pct} % por encima de la media de los tres meses anteriores.',
  'pkn.rpt.obs.deviationUnder': 'El gasto está un {pct} % por debajo de la media de los tres meses anteriores.',
  'pkn.rpt.obs.standsOut': '{name} destaca: {pct} frente a {year}.',
  'pkn.rpt.obs.setAside': 'Apartaste {amount} a lo largo de {year}.',
  'pkn.rpt.obs.yearIncome': 'Los ingresos anuales son {pct} frente a {year}.',
  'pkn.rpt.ask.why': '¿Por qué cambió {name} en este periodo?',
  'pkn.rpt.ask.spendingFallback': 'el gasto',
  'pkn.rpt.ask.saveMore': '¿Qué debería hacer para ahorrar más?',
  'pkn.rpt.ask.vsLastYear': '¿Cómo voy en comparación con el año pasado?',
  'pkn.rpt.ask.rateEnough': '¿Es suficiente mi tasa de ahorro?',
  'pkn.rpt.ask.whatIfContinue': '¿Qué pasa si sigo así?',
  'pkn.rpt.opening': 'Abriendo la impresión …',
  'pkn.rpt.monthly': 'Mensual',
  'pkn.rpt.yearly': 'Anual',
  'pkn.rpt.off': 'No',
  'pkn.rpt.monthReport': 'Informe mensual',
  'pkn.rpt.yearReport': 'Informe anual',
  'pkn.rpt.basedOnBank': 'finanzas personales · basado en datos bancarios importados',
  'pkn.rpt.comparedWith': 'comparado con {period}',
  'pkn.rpt.writtenForYou': 'Escrito para ti · {period}',
  'pkn.rpt.askPlaceholder': 'Pregunta sobre el informe …',
  'pkn.rpt.netCashflow': 'Flujo de caja neto',
  'pkn.rpt.incomeCostPerMonth': 'Ingresos y gastos por mes · {year}',
  'pkn.rpt.outlookSub': 'Si la evolución de {period} continúa durante el próximo año',
  'pkn.rpt.outlookNoteA': 'Si sigues al mismo ritmo que en {period}, el flujo de caja neto podría rondar',
  'pkn.rpt.outlookNoteB': 'durante el próximo año. Pequeños ajustes ahora pueden hacer la curva más pronunciada.',
  'pkn.rpt.footerNote': 'Los informes se generan a partir de extractos de cuentas y tarjetas importados. Los años anteriores están disponibles mientras los datos estén cargados. La comparación muestra el mismo periodo del año anterior.',
  'pkn.tax.prob.veryLikely': 'Muy probable',
  'pkn.tax.prob.likely': 'Probable',
  'pkn.tax.prob.possible': 'Posible',
  'pkn.tax.prob.uncertain': 'Incierto',
  'pkn.tax.heroTag': 'Resumen fiscal de SuperPlumma para {year}',
  'pkn.tax.leadNoEstimate': 'Uso los ingresos, la deuda, el patrimonio y la situación familiar registrados como base de control para {year}. No muestro un importe de impuestos estimado sin una base fiscal completa y verificada.',
  'pkn.tax.leadEstimateA': 'He revisado tu información fiscal de {year}. Espero reducir tus impuestos en aproximadamente',
  'pkn.tax.leadEstimateB': 'y he priorizado las medidas que más importan ahora mismo.',
  'pkn.tax.heroMeta': 'Año fiscal {year} · conjunto de reglas {rules} · las estimaciones deben contrastarse con Skatteetaten',
  'pkn.tax.unversioned': 'sin versión',
  'pkn.tax.actionsFound': '{count} medidas encontradas',
  'pkn.tax.noActionsFound': 'Aún no se han encontrado medidas',
  'pkn.tax.returnDeadline': 'Declaración de impuestos · plazo: 30 de abril',
  'pkn.tax.noDeductions': 'Ninguna deducción está documentada con suficiente seguridad para calcular un beneficio fiscal. Usa el asistente como lista de comprobación y compáralo con la información precumplimentada y la guía oficial de Skatteetaten.',
  'pkn.tax.provisionalEffect': 'Efecto fiscal calculado provisionalmente: {amount}.',
  'pkn.tax.checkpointsFound': '{count} puntos de control encontrados.',
  'pkn.tax.onlyCandidatesNote': 'Solo los candidatos con información suficiente tienen un importe. El resto indica lo que debes responder o documentar.',
  'pkn.tax.showSignalTx': 'Mostrar las transacciones que dieron la señal',
  'pkn.tax.unknownDate': 'Fecha desconocida',
  'pkn.tax.missingHeading': 'Esto falta',
  'pkn.tax.readRule': 'Lee la norma en Skatteetaten',
  'pkn.tax.statusLabel': 'Estado',
  'pkn.tax.mustClarify': 'Requiere aclaración',
  'pkn.tax.noOptimisations': 'No se sugiere ninguna medida fiscal sin una base documentada y una fuente normativa vigente. Contrasta las decisiones de mayor importe con la guía de Skatteetaten o con un asesor autorizado.',
  'pkn.tax.effectThisYear': 'Efecto este año ({year})',
  'pkn.tax.disclaimer': 'Las sugerencias son estimaciones generadas automáticamente a partir de tu información y de las normas fiscales vigentes. No constituyen asesoramiento fiscal individual. Eres responsable del contenido de la declaración de impuestos; consulta con un asesor autorizado para decisiones de mayor importe.',
  'pkn.tax.reviewEmpty': 'El control fiscal revisa ingresos, deuda, patrimonio, inversiones, familia y deducciones, y señala lo que falta o conviene comprobar. Se ejecuta en cuanto se obtiene la información fiscal.',
  'pkn.tax.level.missing': 'Falta',
  'pkn.tax.level.check': 'Revisar',
  'pkn.tax.level.ok': 'OK',
  'pkn.tax.checklist.income': 'Ingresos revisados',
  'pkn.tax.checklist.debt': 'Deuda revisada',
  'pkn.tax.checklist.wealth': 'Patrimonio revisado',
  'pkn.tax.checklist.investments': 'Inversiones revisadas',
  'pkn.tax.checklist.deductions': 'Deducciones revisadas',
  'pkn.tax.checklist.family': 'Información familiar revisada',
  'pkn.tax.pointsRemain': 'puntos pendientes',
  'pkn.tax.pointsLeft': 'puntos restantes',
  'pkn.tax.qualityAssured': '{score} % verificado',
  'pkn.tax.missingWhenConnected': 'Cuando se conecten los ingresos, la deuda, el patrimonio y la información familiar, mostraré exactamente qué falta para tener plena seguridad.',
  'pkn.tax.goThere': 'Ir allí',
  'pkn.tw.noInfo': 'Todavía no se ha obtenido información fiable para este paso. Selecciona las circunstancias pertinentes en el asistente y contrástalas con los certificados anuales y la declaración de impuestos.',
  'pkn.tw.pickAll': 'Selecciona todo lo que se aplicó en el año fiscal. Tus elecciones determinan qué preguntas de control recibes.',
  'pkn.tw.situation.enslig': 'Soltero/a',
  'pkn.tw.situation.gift': 'Casado/a',
  'pkn.tw.situation.samboer': 'Conviviente',
  'pkn.tw.situation.barn': 'Hijos',
  'pkn.tw.situation.student': 'Estudiante',
  'pkn.tw.situation.pensjonist': 'Pensionista',
  'pkn.tw.situation.naering': 'Trabajador autónomo',
  'pkn.tw.topic.union': 'Pagué cuotas sindicales',
  'pkn.tw.topic.commuter': 'Pernocté fuera de casa por trabajo',
  'pkn.tw.topic.refinancing': 'Refinancié préstamos',
  'pkn.tw.topic.debt-interest': 'Tuve préstamos o gastos de préstamos que hay que comprobar',
  'pkn.tw.topic.bsu': 'Ingresé dinero en una cuenta BSU',
  'pkn.tw.topic.ips': 'Ingresé dinero en una cuenta IPS',
  'pkn.tw.topic.gifts': 'Hice donaciones a organizaciones sin ánimo de lucro',
  'pkn.tw.topic.share-loss': 'Vendí acciones o valores con pérdidas',
  'pkn.tw.topic.property-loss': 'Vendí una vivienda o una casa de vacaciones con pérdidas',
  'pkn.tw.topic.rental-costs': 'Tuve alquileres sujetos a impuestos',
  'pkn.tw.topic.foreign-tax': 'Pagué impuestos en el extranjero',
  'pkn.tw.topic.home-office': 'Tuve una habitación propia usada solo como oficina en casa',
  'pkn.tw.topic.actual-work-costs': 'Mis gastos laborales reales pueden superar la deducción mínima estándar',
  'pkn.tw.topic.job-move': 'Me mudé por un nuevo trabajo',
  'pkn.tw.topic.education': 'Pagué formación relacionada con el trabajo',
  'pkn.tw.topic.doctorate': 'Tuve gastos por la defensa de una tesis doctoral',
  'pkn.tw.topic.fisher': 'Trabajé como pescador',
  'pkn.tw.topic.seafarer': 'Trabajé como marino',
  'pkn.tw.topic.young-worker': 'Skatteetaten me seleccionó para la prueba piloto de la deducción por trabajo para jóvenes',
  'pkn.tw.topic.co-op-housing': 'Tuve una vivienda en una cooperativa, una sociedad de vivienda o una comunidad de propietarios',
  'pkn.tw.topic.foreign-worker': 'Fui trabajador extranjero',
  'pkn.tw.topic.partial-year': 'Viví en Noruega solo una parte del año',
  'pkn.tw.topic.hobby-income': 'Tuve un pasatiempo, trabajos ocasionales u otros ingresos extra',
  'pkn.tw.commuted': 'Viajé entre mi casa y un lugar de trabajo fijo',
  'pkn.tw.fuelNote': 'Los gastos de combustible solo se usan como indicio. El cálculo usa la distancia más corta y los días de viaje reales. No deben contarse los días de teletrabajo.',
  'pkn.tw.homeAddress': 'Dirección de casa',
  'pkn.tw.workAddress': 'Dirección del lugar de trabajo fijo',
  'pkn.tw.shortestDistance': 'Distancia más corta de ida',
  'pkn.tw.travelDays': 'Días de viaje reales',
  'pkn.tw.presetFullTime': 'Jornada completa · 230 días',
  'pkn.tw.presetHalfTime': '50 % · 115 días',
  'pkn.tw.presetCustom': 'Número propio',
  'pkn.tw.distanceChecked': 'He comprobado la distancia más corta entre las direcciones',
  'pkn.tw.tollFerry': 'Gastos documentados de peajes/transbordadores (se comprueban por separado)',
  'pkn.tw.childrenNote': 'Los hijos no dan derecho automáticamente a una deducción. Indica los hijos que tenían 11 años o menos al final del año fiscal y los gastos documentados de cuidado infantil.',
  'pkn.tw.childrenUnder12': 'Hijos de 11 años o menos',
  'pkn.tw.childrenSpecial': 'Hijos de 12 años o más con necesidades especiales de cuidado',
  'pkn.tw.childcareCosts': 'Gastos documentados de cuidado infantil',
  'pkn.tw.navSupport': 'Ayuda para el cuidado infantil de NAV',
  'pkn.tw.extraKm': 'Km adicionales al día para el cuidado infantil',
  'pkn.tw.extraDays': 'Días con transporte adicional',
  'pkn.tw.bankReports': 'Los bancos y proveedores informan automáticamente de muchos datos. Marca las circunstancias que todavía hay que conciliar.',
  'pkn.tw.deductionsFound': 'Se han encontrado {count} posibles deducciones o puntos de control.',
  'pkn.tw.noCandidates': 'Todavía no se ha encontrado ningún candidato.',
  'pkn.tw.amountsNote': 'Los importes solo se muestran cuando se puede calcular la base. El resto son preguntas que hay que comprobar.',
  'pkn.tw.finishNote': 'Finalizar significa que has repasado las preguntas, no que las deducciones estén aprobadas ni que la declaración de impuestos esté lista para presentarse.',
  'pkn.tw.sub': 'Control exhaustivo del año fiscal {year}',
  'pkn.tw.stepWord': 'Paso',
  'pkn.tw.checklistReviewed': 'La lista de comprobación fiscal se ha revisado',
});
